import { useEffect } from "react";

const MARKETING_SIGNUP_URL = "https://saleslox.com/signup";

export function SignupRedirectPage() {
  useEffect(() => {
    window.location.replace(MARKETING_SIGNUP_URL);
  }, []);

  return null;
}
